<template>
  <v-container
    grid-list-xl
    fluid
  >
    <LoadingState
      :loading="loading"
      color="primary"
    />
    <v-layout
      v-if="!loading"
      row
      wrap
    >
      <v-flex
        xs12
      >
        <v-widget
          :title="$t('Permission Details')"
          class="mb-4"
        >
          <div slot="widget-content">
            <v-form>
              <v-text-field
                v-model="permission.name"
                :error-count="permission.displayErrors('name').length"
                :error-messages="permission.displayErrors('name')"
                :label="$t('Name')"
                outline
              />
              <v-text-field
                v-model="permission.code"
                :error-count="permission.displayErrors('code').length"
                :error-messages="permission.displayErrors('code')"
                :label="$t('Code')"
                disabled
                outline
              />
              <v-select
                :items="apps"
                v-model="permission.app"
                :label="$t('App')"
                outline
              />
              <v-select
                :items="storeNames"
                v-model="permission.store"
                :label="$t('Store')"
                outline
              />
              <v-select
                :items="resources"
                v-model="permission.resourceProp"
                :label="$t('Resource')"
                outline
              />
              <v-select
                v-if="permission.resourceProp !== ''"
                :items="actions[permission.resourceProp]"
                v-model="permission.action"
                :label="$t('Action')"
                outline
              />
            </v-form>
          </div>
        </v-widget>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LoadingState from '@/components/LoadingState'
import SettingsService from '@/modules/Settings/service'
import { mapGetters } from 'vuex'

export default {
  name: 'PermissionSinglePage',
  components: {
    LoadingState
  },

  props: {
    permission: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      savingPermission: false,
      storeNames: ['*'],
      apps: ['*'],
      resources: ['*'],
      actions: {
        '*': ['*', 'read', 'create', 'update', 'delete', 'manage']
      }
    }
  },

  computed: {
    ...mapGetters(['stores']),

    loading () {
      return Object.entries(this.permission).length === 0
    },

    title () {
      return (
        this.permission && `${this.permission.name}`
      )
    },

    disabled () {
      return this.permission.inProgress || !this.permission.isChanged
    }
  },

  async mounted () {
    let loadedStoreNames = this.stores.map(store => store.code)
    this.$set(this, 'storeNames', this.storeNames.concat(loadedStoreNames))

    const abilities = await SettingsService.loadAbilities()

    if (abilities.services !== undefined) {
      this.apps = this.apps.concat(abilities.services)
    }

    if (abilities.actions !== undefined) {
      let actions = abilities.actions

      for (let k in actions) {
        if (actions.hasOwnProperty(k)) {
          this.resources.push(k)
          this.actions[k] = ['*'].concat(actions[k])
        }
      }
    }
  }
}
</script>
